import urlApi from './urlApi';
import { getLongReadPosts } from './getLongReadPosts';
export var DELETE_LR_POST_REQUEST = 'DELETE_LR_POST_REQUEST';
export var DELETE_LR_POST_SUCCESS = 'DELETE_LR_POST_SUCCESS';
export var DELETE_LR_POST_ERROR = 'DELETE_LR_POST_ERROR';
export function deleteLongReadPost(id, idUser, idLongRead, sign) {
    return function (dispatch) {
        dispatch({
            type: DELETE_LR_POST_REQUEST,
        });
        var onSubmit = function (res) {
            dispatch({
                type: DELETE_LR_POST_SUCCESS,
                payload: res,
            });
            if (res) {
                dispatch(getLongReadPosts(idUser, idLongRead, sign));
                return;
            }
        };
        var onError = function (res) {
            dispatch({
                type: DELETE_LR_POST_ERROR,
            });
        };
        urlApi().deleteLongReadPost(id, onSubmit, onError);
    };
}
//# sourceMappingURL=deleteLongReadPost.js.mapimport urlApi from './urlApi';
import { getLongReadPosts } from './getLongReadPosts';
export var DELETE_LR_POST_REQUEST = 'DELETE_LR_POST_REQUEST';
export var DELETE_LR_POST_SUCCESS = 'DELETE_LR_POST_SUCCESS';
export var DELETE_LR_POST_ERROR = 'DELETE_LR_POST_ERROR';
export function deleteLongReadPost(id, idUser, idLongRead, sign) {
    return function (dispatch) {
        dispatch({
            type: DELETE_LR_POST_REQUEST,
        });
        var onSubmit = function (res) {
            dispatch({
                type: DELETE_LR_POST_SUCCESS,
                payload: res,
            });
            if (res) {
                dispatch(getLongReadPosts(idUser, idLongRead, sign));
                return;
            }
        };
        var onError = function (res) {
            dispatch({
                type: DELETE_LR_POST_ERROR,
            });
        };
        urlApi().deleteLongReadPost(id, onSubmit, onError);
    };
}
//# sourceMappingURL=deleteLongReadPost.js.map